<template>
  <div
    class="p-6 bg-white rounded-lg"
  >
    <div
      class="mb-4 pb-4 flex items-center border-b"
    >
      <div
        class="flex-no-shrink w-12 h-12 rounded-lg text-white"
        :class="this.module.settings.icon_color ? this.module.settings.icon_color : 'bg-tertiary'"
      >
        <icon v-if="this.module.settings.icon" :name="this.module.settings.icon" class="p-1" />
        <icon v-else name="download" class="p-1" />
      </div>
      <h3
        class="text-2xl font-medium ml-4"
      >
        {{ module.title || 'Related Media' }}
      </h3>
    </div> <!-- end of header -->

    <div
      class="mb-6"
    >
      <p
        class="text-base leading-tight mb-6"
        v-html="nl2br(module.settings.intro)"
      >
      </p>
    </div> <!-- end of intro -->

    <div
      class="mb-6"
    >
      <div
        v-for="content in downloadable"
        :key="content.path"
        class="mb-4"
      >
        <a
          :href="content.path"
          target="_blank"
          class="no-underline text-tertiary flex items-center"
        >
          <div class="w-12 h-12 mr-2 p-1">
            <icon name="pdf" class="text-tertiary" />
          </div>
          <span
            class="border-b border-tertiary mr-2 pb-1"
          >
            {{ content.filename }}
          </span>
        </a>
        <span
          v-if="content.description"
          class="text-grey-darker"
        >
          {{ content.description }}
        </span>
      </div>

      <div
        v-for="video in videos"
        :key="video.src"
      >
        <a
          :href="video.src"
          target="_blank"
          class="no-underline text-tertiary flex items-center mb-4"
        >
          <div class="w-12 h-12 mr-2 p-1">
            <icon name="videoettes" class="text-tertiary"></icon>
          </div>
          <span
            class="border-b border-tertiary mr-2"
          >
            {{ video.title || video.src }}
          </span>
        </a>
      </div>
    </div> <!-- end of content -->

    <div
      class="mb-6"
    >
      <p
        class="text-base leading-tight mb-6"
        v-html="nl2br(module.settings.outro)"
      >
      </p>
    </div> <!-- end of outro -->
  </div>
</template>

<script>
import { nl2br } from '@/helpers'

export default {
  props: ['module'],

  computed: {
    settings () {
      return this.module.settings
    },

    downloadable () {
      return this.settings.contents.filter(file => file.path)
    },

    videos () {
      return this.settings.videos.filter(video => video.src)
    }
  },

  methods: {
    nl2br
  }
}
</script>
